import React from 'react';
import Container from 'react-bootstrap/Container';

const NotFound = () => (
   <>
      <div className="text-white bg-secondary py-5">
         <Container>
            <h2>Ooops!</h2>
         </Container>
      </div>
      <div className="text-center py-5">
         <Container>
            Conteúdo não encontrado...
         </Container>
      </div>

   </>
);

export default NotFound;